import * as yup from 'yup'
import { validarCnpj } from './validar-cnpj'
import { validarCpf } from './validar-cpf'
import yuiLocale from './yui-locale'

yup.setLocale(yuiLocale)

yup.addMethod(yup.string, 'unique', function uniqueVerifier(message) {
  return this.test('unique', message, function uniqueVerifierTest(value) {
    if (!value) {
      return true
    }
    const errors = this.parent.map(v => (v === value ? v : null)).filter(v => v)

    return errors.length <= 1
  })
})

yup.addMethod(
  yup.string,
  'notEqualTo',
  function notEqualToTest(ref, message, normalizer) {
    return this.test({
      name: 'notEqualTo',
      exclusive: false,
      message,
      params: {
        reference: ref.path
      },
      test(value) {
        if (!value) {
          return true
        }

        const customNormalizer = normalizer || (v => v)

        const otherValue = this.parent[ref.path]

        if (!otherValue) {
          return true
        }

        if (otherValue instanceof Array) {
          return !otherValue.some(
            v => customNormalizer(v) === customNormalizer(value)
          )
        }

        return customNormalizer(value) !== customNormalizer(otherValue)
      }
    })
  }
)

yup.addMethod(yup.string, 'cnpj', function cnpjVerifierTest(message) {
  return this.test('cnpj', message, value => !value || validarCnpj(value))
})

yup.addMethod(yup.string, 'cpf', function cpfVerifierTest(message) {
  return this.test('cpf', message, value => !value || validarCpf(value))
})

export default yup
